import { useState } from "react";
import { format, parseISO, startOfToday } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { Calendar } from "../ui/calendar";

export default function DateField({ id, value, onChange, testid, placeholder = "Pick a date" }) {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  return (
    <div className="relative">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button id={id} type="button" data-testid={testid} className="gi-input flex items-center gap-2 text-left pr-10">
            <CalendarDays className="w-4 h-4 text-faint shrink-0" aria-hidden="true" />
            <span className={date ? "text-ink" : "text-faint"}>{date ? format(date, "EEE, d MMM yyyy") : placeholder}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-auto p-0 bg-surface border-line text-ink rounded-xl" data-testid={`${testid}-calendar`}>
          <Calendar mode="single" selected={date} defaultMonth={date} disabled={{ before: startOfToday() }}
            onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
            classNames={{ day_selected: "bg-brand text-onbrand hover:bg-brand hover:text-onbrand focus:bg-brand focus:text-onbrand", day_today: "bg-brand-soft text-brand-text" }} />
        </PopoverContent>
      </Popover>
      {date && (
        <button type="button" aria-label="Clear date" data-testid={`${testid}-clear`} onClick={() => onChange("")}
          className="absolute right-1.5 top-1/2 -translate-y-1/2 w-8 h-8 rounded-lg flex items-center justify-center text-faint hover:text-ink hover:bg-subtle">
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
